/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { LayoutFixer } from '@wix/native-pro-gallery-layout-fixer';
export const WixProGalleryWithLayoutFixer = WixProGallery => props => {
  return /*#__PURE__*/React.createElement(WixProGallery, props, props.children, !props.disableLayoutFixer && (props.isPrerenderMode || !props.firstInteractionRecorded) && /*#__PURE__*/React.createElement(LayoutFixer, {
    isPrerenderMode: props.isPrerenderMode,
    items: props.items,
    id: props.id,
    options: props.flattenOptions,
    manualOptions: props.manualOptions
  }));
};
//# sourceMappingURL=withLayoutFixer.js.map